import {
  INITIALIZE_TERMS,
  INITIALIZE_ATTACHMENTTYPES,
  INITIALIZE_CHANNELS,
  INITIALIZE_LANGUAGES,
} from "./staticDataActions";

export const initialStaticDataState = {
  terms: [],
  attachmentTypes: [],
  channels: [],
  languages: [],
};

const staticDataReducer = (state = initialStaticDataState, action) => {
  switch (action.type) {
    case INITIALIZE_TERMS: {
      const { terms } = action.payload;
      return {
        ...state,
        terms,
      };
    }
    case INITIALIZE_ATTACHMENTTYPES: {
      const { attachmentTypes } = action.payload;
      // console.log('INITIALIZE_ATTACHMENTTYPES: ', attachmentTypes);
      return {
        ...state,
        attachmentTypes,
      };
    }
    case INITIALIZE_LANGUAGES: {
      const { languages } = action.payload;
      return {
        ...state,
        isChannelInitialized: true,
        languages,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default staticDataReducer;
